export function getHasValue(
  value?: string | number | readonly string[]
): boolean {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  return Boolean(value);
}
